export default [
  {
    apiKey: 'sreSeeAmaSelection',
    label: 'SRE/SEE Preference',
    readOnly: true,
    colspan: 3
  }
]
